var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldDisplayAddedDays())?_c('div',{staticClass:"added-date__wrapper"},[_c('div',{staticClass:"added-date__value"},[_c('span',[_vm._v(_vm._s(_vm.getAddedInDaysText()))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }